import { Overline } from "@/components/site/Mark";
import { Reveal } from "@/components/site/Reveal";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Information we collect", "When you submit an enquiry, we collect the details you provide, such as your name, email address, phone number, market of interest and message."],
      ["How we use it", "We use this information to respond to your enquiry, follow up on property marketing opportunities you have expressed interest in, and communicate with you about our services."],
      ["Sharing", "Where relevant to your enquiry, your details may be shared with the real-estate professionals connected to the opportunity you asked about. We do not sell your personal information."],
      ["Retention & your rights", "We keep enquiry information only as long as needed for these purposes. You may ask us to access, correct or delete your information at any time."],
      ["Contact", "For privacy questions, email support@vkenterpriseconsult.com or call +91 87968 81958."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    sections: [
      ["Our services", "VK Enterprises provides property marketing, lead-generation and enquiry-support services. Information on this website is provided for general information only."],
      ["No official representation", "Unless formally authorized, VK Enterprises does not represent itself as an official partner or agent of any third-party developer, broker or real-estate brand."],
      ["No advice", "Content on this website does not constitute legal, financial or investment advice. Prospective buyers should seek independent professional advice before making decisions."],
      ["Availability", "Property opportunities referenced through our marketing are subject to availability and the applicable business arrangements."],
      ["Contact", "Questions about these terms can be sent to support@vkenterpriseconsult.com."],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  return (
    <main className="bg-[#070E17] pb-28 pt-40" data-testid={`legal-page-${kind}`}>
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Reveal>
          <Overline>VK Enterprises — Legal</Overline>
          <h1 className="font-serif-d mt-6 text-5xl font-medium text-white sm:text-6xl">{c.title}</h1>
        </Reveal>
        <div className="mt-14">
          {c.sections.map(([h, p], i) => (
            <Reveal key={h} delay={i * 0.05}>
              <div className="border-t border-[rgba(212,175,55,0.18)] py-8">
                <h2 className="font-serif-d text-2xl text-[#E6C280]">{h}</h2>
                <p className="mt-3 text-base leading-relaxed text-slate-300">{p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </main>
  );
}
